// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3p4SB","footer":"ModalCreateQualiphyProcedure_footer__1bXKU","additionData":"ModalCreateQualiphyProcedure_additionData__3RyxF"};